import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { useGetRefundTypesQuery } from '../../../../../services/RefundService';
import { updateRefundDetailsAction as updateRefundDetails } from '../../../../../services/RefundService/slice';

export const RefundCategoryField: React.FC = () => {
    const dispatch = useAppDispatch();
    const { currentRefund } = useAppSelector(state => state.refund);
    const { data: refundTypes, isLoading: isLoadingTypes, error: typesError } = useGetRefundTypesQuery();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(updateRefundDetails({ refundCategory: event.target.value }));
    };

    const currentValue = currentRefund?.refundDetail?.refundCategory || '';
    const availableValues = refundTypes?.map(t => t.value) || [];
    
    // Use empty string if current value is not in available options
    const safeValue = availableValues.includes(currentValue) ? currentValue : '';

    return (
        <TextField
            label="Refund Category"
            select
            value={safeValue}
            onChange={handleChange}
            size="small"
            disabled={isLoadingTypes || !refundTypes?.length}
            sx={{ flex: 1 }}
        >
            {refundTypes?.length ? (
                refundTypes.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.name}
                    </MenuItem>
                ))
            ) : (
                <MenuItem disabled value="">
                    Loading options...
                </MenuItem>
            )}
        </TextField>
    );
};

export default RefundCategoryField;
